module.exports = __webpack_public_path__ + "img/20.35044d60.png";